import React from "react";

type DataContainerProps = {
  children: React.ReactNode;
};

export const DataContainer: React.FC<DataContainerProps> = ({ children }) => {
  return <div className="flex flex-col gap-2 pb-6">{children}</div>;
};
